import { CLIENT_SOURCE_TYPE } from 'global.enums';

export const getClientSourceType = (clientSourceType: CLIENT_SOURCE_TYPE): number => {
  return clientSourceType === CLIENT_SOURCE_TYPE.DIRECT ? 1 : 2;
};
